export const en = {
  common: {
    dashboard: 'Dashboard',
    cancel: 'Cancel',
    save: 'Save',
    location: 'Location',
    type: 'Type',
    depot: 'Depot',
    date: 'Date',
  },
  dashboard: {
    title: 'Dashboard',
    collecting: {
      title: 'Collecting',
      subtitle: 'Quick start',
      buttonText: 'New collecting',
    },
    returning: {
      title: 'Returning',
      subtitle: 'Quick start',
      buttonText: 'New returning',
    },
    transactions: {
      title: 'Transactions',
    },
  },
  userMenu: {
    account: 'Account',
    language: {
      label: 'Language',
      dutch: 'Dutch',
      english: 'English',
    },
    logout: 'Log out',
    businessAssociations: 'Business associations',
    loadingBusinessAssociations: 'Loading business associations...',
    role: 'User',
    businessAssociationSelector: {
      title: 'Select business association',
      open: 'View all business associations',
      searchLabel: 'Search business associations',
      searchPlaceholder: 'Search by name or number',
      noResults: 'No business associations found',
    },
  },
  businessAssociationBanner: {
    workingFor: 'Working for:',
    ownUse: 'Own use:',
  },
  sidebar: {
    newCollecting: 'New collecting',
    newReturning: 'New returning',
    transactions: 'Transactions',
    openingHours: 'Opening hours',
  },
  errorFallback: {
    genericError: 'An error has occurred',
    pageLoadError:
      'The page could not be loaded correctly. You can return to the dashboard.',
    backToDashboard: 'Back to dashboard',
  },
  transactions: {
    deleteDialog: {
      title: 'Confirm deletion',
      heading: 'Are you sure you want to delete this?',
      description:
        'The transaction will be permanently deleted. This action cannot be undone.',
      confirm: 'Delete',
    },
    empty: {
      title: 'No transactions found',
      description:
        "There are currently no transactions with the status '{{selectedTab}}'.",
    },
    viewAll: 'View all transactions',
    title: 'Transactions',
    codesCount: '{{count}} codes',
    table: {
      code: 'CODE',
      stw: 'TR',
      stpl: 'STCK',
      stk: 'PS',
      total: 'Total',
    },
    tabs: {
      open: 'Open',
      closed: 'Closed',
    },
    toolbar: {
      searchPlaceholder: 'Search by transaction number',
      filterButton: 'Filter',
      exportSelect: 'Select',
      select: 'Select',
      cancelSelect: 'Cancel',
      download: 'Download ({{count}})',
    },
    selection: {
      selectAll: 'Select all',
      remove: 'Remove',
      selectTransaction: 'Select transaction {{transactionId}}',
    },
    pdf: {
      transactionType: 'Transaction type',
      customerName: 'Customer name',
      customerNumber: 'Customer number',
      transporterName: 'Transporter name',
      transporterNumber: 'Transporter number',
      transactionDate: 'Transaction date',
      createdDate: 'Created date',
      transactionStatus: 'Transaction status',
      transactionNumber: 'Transaction number',
      item: 'Item',
      stapelwagen: 'Trolley',
      stapel: 'Stacks',
      stuks: 'Pieces',
      total: 'Total',
      notes: 'Notes',
    },
    filters: {
      type: 'Transaction type',
      date: 'Date',
      businessAssociation: 'Business association',
      businessAssociationPlaceholder: 'Search business associations',
    },
  },
  transactionType: {
    UitgifteDock: 'Collecting Dock',
    UitgifteMobiel: 'Collecting Mobile',
    UitgifteVast: 'Collecting Fixed',
    InnameVast: 'Returning Fixed',
    InnameMobiel: 'Returning Mobile',
  },
  collecting: {
    backToOverview: 'Back to overview',
    editCollecting: 'Edit collecting',
    newCollecting: 'New collecting',
    editAssociationError:
      'You cannot edit a transaction from another business association',
    loadingTransactionError: 'An error occurred while loading the transaction.',
    transactionNotFound: 'Transaction not found.',
    submitError: 'An error occurred while submitting the transaction.',
    updatedSuccess: 'Collecting has been updated',
    sentSuccess: 'Collecting has been sent',
    step1: {
      heading: 'Location & Date',
      locationLabel: 'Choose your location',
      collectingTypeLabel: 'How is the collecting taking place?',
      collectingType: 'Collecting type',
      packagingLocation: 'Packaging location: {{fixedDepotLabel}}',
      packagingLocationPlaceholder: 'Select a packaging location',
      customerLocationPlaceholder: 'Select a customer location',
      unknownDepotLabel: 'Unknown location',
    },
    step2: {
      heading: 'Articles & Quantities',
      fillArticles: 'Enter your articles',
      addRow: 'Add row',
      articleNumbering: 'Article {{rowNumber}}',
    },
    step3: {
      heading: 'Complete',
      summary: 'Check your details',
      checkDetails: 'Check your details',
      articles: 'Articles',
      note: 'Note',
      notePlaceholder: 'Do you have a comment?',
      submit: 'Submit',
      workingFor: 'Working for:',
      customerLocation: 'Customer location:',
      code: 'CODE',
      stw: 'TR',
      stpl: 'STCK',
      stk: 'PS',
      total: 'Total',
    },
    transactionTypeInformation: {
      UitgifteDock: 'Evening order at a fixed location',
      UitgifteMobiel: 'Delivery in your customer box',
      UitgifteVast: 'Pickup at a fixed location',
    },
    fustcodes: {
      selectHubFirst: 'Select a hub first',
      noneAvailable: 'No packaging codes available',
      notOrderable: 'This packaging code cannot be ordered',
    },
    hubTimes: {
      nowOpenUntilInfinity: 'Open now (until infinity)',
      viewAllOpeningHours: 'View all opening hours',
    },
  },
  returning: {
    backToOverview: 'Back to overview',
    editReturning: 'Edit returning',
    newReturning: 'New returning',
    editAssociationError:
      'You cannot edit a transaction from another business association',
    loadingTransactionError: 'An error occurred while loading the transaction.',
    transactionNotFound: 'Transaction not found.',
    submitError: 'An error occurred while submitting the transaction.',
    updatedSuccess: 'Returning has been updated',
    sentSuccess: 'Returning has been sent',
    step1: {
      heading: 'Location & Date',
      locationLabel: 'Choose your location',
      collectingTypeLabel: 'How is the returning taking place?',
      collectingType: 'Returning type',
      packagingLocation: 'Packaging location: {{fixedDepotLabel}}',
      packagingLocationPlaceholder: 'Select a packaging location',
      customerLocationPlaceholder: 'Select a customer location',
      unknownDepotLabel: 'Unknown location',
    },
    step2: {
      heading: 'Articles & Quantities',
      fillArticles: 'Enter your articles',
      addRow: 'Add row',
      articleNumbering: 'Article {{rowNumber}}',
    },
    step3: {
      heading: 'Complete',
      summary: 'Check your details',
      checkDetails: 'Check your details',
      articles: 'Articles',
      note: 'Note',
      notePlaceholder: 'Do you have a comment?',
      submit: 'Submit',
      workingFor: 'Working for:',
      customerLocation: 'Customer location:',
      code: 'CODE',
      stw: 'TR',
      stpl: 'STCK',
      stk: 'PS',
      total: 'Total',
    },
    transactionTypeInformation: {
      InnameMobiel: 'Pickup from your customer box',
      InnameVast: 'Drop-off at a fixed location',
    },
    fustcodes: {
      selectHubFirst: 'Select a hub first',
      noneAvailable: 'No packaging codes available',
      notOrderable: 'This packaging code cannot be ordered',
    },
    hubTimes: {
      nowOpenUntilInfinity: 'Open now (until infinity)',
      viewAllOpeningHours: 'View all opening hours',
    },
  },
  inventory: {
    title: 'My inventory',
    unitCount: '{{count}} items',
  },
  warnings: {
    spendingLimit:
      'Your issuance ceiling for balance-bearing items has (almost) been reached. If the ceiling exceeds the limit when the actual issuance is made, issuance is not possible. Keep this in mind.',
  },
} as const
